<template>
  <div class="list-box">
    <ul class="list">
      <li v-for="(item, index) in list" :key="index" class="item">
        <div class="img-aspect-fit-warp item-img">
          <img :src="item.pic" />
        </div>
        <div class="item-right">
          <div class="item-right__title">
            <span class="title">{{ item.title }}</span>
            <span class="price">{{ item.price }}元</span>
          </div>
          <span class="item-right__text">类别：{{ item.type }}</span>
          <span class="item-right__text">订单号：{{ item.order_num }}</span>
          <span class="item-right__text">使用期限：{{ item.buy_time }}天</span>
          <span class="item-right__text">购买时间：{{ item.create_time }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getOrderList } from '@/api/index'
export default {
  data() {
    return {
      list: [],
      current_page: 1,
    }
  },
  created() {
    this.orderList()
  },
  mounted() {},
  methods: {
    orderList() {
      getOrderList({ page: 1 }).then((res) => {
        res.data.map((res) => {
          if (res.type == 1) {
            res.type = '课程资源'
          } else if (res.type == 2) {
            res.type = '章节练习/考试'
          } else if (res.type == 3) {
            res.type = '报名'
          }
          res.pic = 'http://edu.dxxf119.cn/' + res.pic
        })
        this.list = res.data
        this.page = res.current_page
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.list-box {
  width: 100%;
  background: #fff;
}
.list {
  list-style: none;
  width: 100%;
  padding: 17px 13px;
  box-sizing: border-box;
  margin: 0;
}
.item {
  margin: 0;
  width: 100%;
  display: flex;
  padding: 13px 15px;
  box-shadow: 0 0 9px rgba($color: #000000, $alpha: 0.16);
  border-radius: 8px;
  margin-bottom: 15px;
  align-items: center;
  border: none;
  .item-img {
    width: 72px;
    height: 87px;
    margin-right: 10px;
  }
  .item-right {
    display: flex;
    flex: 1;
    flex-flow: column;
  }
  .item-right__title {
    display: flex;
    justify-content: space-between;
    .title {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      flex: 1;
    }
    .price {
      color: #214ecf;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .item-right__text {
    width: 190px;
    line-height: 25px;
    color: #999;
    font-size: 13px;
  }
}
</style>
